import { Store } from '@tanstack/react-store'

export type ScoreViewtype = 'distribution' | 'time-series'

export const selectedScoreViewStore = new Store<ScoreViewtype>('distribution')
